import type {
  AnyEvent,
  AnyEventVariant,
  SystemEvent,
  SystemEventType,
} from './schemas'

import { ONE_MINUTE_MS } from '~/shared/constants/time'
import { Logger } from '~/shared/logger'

export const logger = new Logger('tria/sse')

export const CONNECTED_TIMEOUT = ONE_MINUTE_MS // 1 minutes
export const SSE_PING_TIMEOUT = 5 * ONE_MINUTE_MS // 5 minutes

/**
 * Small helper typescript type guard factory
 */
export function variantOf<T extends AnyEvent>(type: AnyEventVariant) {
  return (message: AnyEvent): message is T => message.event === type
}

/**
 * Small helper typescript type guard factory
 */
export function typeOf<T extends SystemEvent['data']>(type: SystemEventType) {
  return (message: SystemEvent['data']): message is T => message.type === type
}
